// src/hooks/QuestionnaireAnalyticsHooks.js

import { useState, useEffect } from "react";


export function useQuestionnaireAnalytics() {

    const [questionnaires, setQuestionnaires] = useState([]);
    const [users, setUsers] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [analytics, setAnalytics] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(function initialiseDummyData() {

        setLoading(true);

        // Questionnaires
        const dummyQuestionnaires = [
            { id: 1, title: "Workplace Utilisation & Experience Survey" },
			{ id: 2, title: "Moves & Strategy 2025" },
			{ id: 3, title: "Consultancy Services Feedback" },
			{ id: 4, title: "Health & Safety Consultancy Feedback" }
        ];

        // Users (10)
        const dummyUsers = [
            { id: 1, name: "Roy Walker" },
            { id: 2, name: "Sarah Jones" },
            { id: 3, name: "Tom Richardson" },
            { id: 4, name: "Priya Patel" },
            { id: 5, name: "James O'Neill" },
            { id: 6, name: "Laura Chen" },
            { id: 7, name: "Ben Carter" },
            { id: 8, name: "Aisha Khan" },
            { id: 9, name: "Michael Brown" },
            { id: 10, name: "Emma Wilson" }
        ];

        // Questions (your exact ones)
        const dummyQuestions = [
            {
                id: 1,
                text: "We have enough desks to deal with our teams’ needs 4 days a week",
                info: "Add more details if you wish."
            },
            {
                id: 2,
                text: "Our desks are set up with the correct IT (monitor, keyboard, mouse, port replicator)",
                info: "Add more details if you wish."
            },
            {
                id: 3,
                text: "We can book the formal meeting spaces we need 90% of the time",
                info: "Include all desks in your wider pond."
            },
            {
                id: 4,
                text: "Colleagues are responding to the request to use all 5 days of the working week by coming in more on Mondays and Fridays",
                info: "Add more details if you wish."
            },
            {
                id: 5,
                text: "We have more physical storage than we need",
                info: "Include personal lockers, cupboards and other shared storage."
            },
            {
                id: 6,
                text: "There are enough spaces to have informal meetings and collaboration sessions",
                info: "Add more details if you wish."
            }
        ];

        // Analytics payload (mirrors future REST shape)
        const dummyAnalytics = {

            // Average score by question (0–100 scale)
            scoresByQuestion: [
                { questionId: 1, score: 74 },
                { questionId: 2, score: 68 },
                { questionId: 3, score: 61 },
                { questionId: 4, score: 55 },
                { questionId: 5, score: 70 },
                { questionId: 6, score: 63 }
            ],

            // Scores over time per question (for line charts)
            scoresOverTime: [
                { date: "2025-10-01", questionId: 1, score: 70 },
                { date: "2025-11-01", questionId: 1, score: 72 },
                { date: "2025-12-01", questionId: 1, score: 74 },

                { date: "2025-10-01", questionId: 2, score: 65 },
                { date: "2025-11-01", questionId: 2, score: 66 },
                { date: "2025-12-01", questionId: 2, score: 68 },

                { date: "2025-10-01", questionId: 3, score: 58 },
                { date: "2025-11-01", questionId: 3, score: 60 },
                { date: "2025-12-01", questionId: 3, score: 61 },

                { date: "2025-10-01", questionId: 4, score: 50 },
                { date: "2025-11-01", questionId: 4, score: 52 },
                { date: "2025-12-01", questionId: 4, score: 55 },

                { date: "2025-10-01", questionId: 5, score: 68 },
                { date: "2025-11-01", questionId: 5, score: 69 },
                { date: "2025-12-01", questionId: 5, score: 70 },

                { date: "2025-10-01", questionId: 6, score: 60 },
                { date: "2025-11-01", questionId: 6, score: 61 },
                { date: "2025-12-01", questionId: 6, score: 63 }
            ],

            // Individual user scores (for drilldowns / answer distributions)
            answersByUser: [
                { userId: 1, questionId: 1, score: 80 },
                { userId: 2, questionId: 1, score: 75 },
                { userId: 3, questionId: 1, score: 70 },
                { userId: 4, questionId: 1, score: 78 },
                { userId: 5, questionId: 1, score: 72 },
                { userId: 6, questionId: 1, score: 76 },
                { userId: 7, questionId: 1, score: 69 },
                { userId: 8, questionId: 1, score: 74 },
                { userId: 9, questionId: 1, score: 71 },
                { userId: 10, questionId: 1, score: 77 },

                { userId: 1, questionId: 2, score: 65 },
                { userId: 2, questionId: 2, score: 70 },
                { userId: 3, questionId: 2, score: 68 },
                { userId: 4, questionId: 2, score: 72 },
                { userId: 5, questionId: 2, score: 66 },
                { userId: 6, questionId: 2, score: 69 },
                { userId: 7, questionId: 2, score: 64 },
                { userId: 8, questionId: 2, score: 71 },
                { userId: 9, questionId: 2, score: 67 },
                { userId: 10, questionId: 2, score: 73 }

                // You can easily extend this per question as needed
            ]
        };

        setQuestionnaires(dummyQuestionnaires);
        setUsers(dummyUsers);
        setQuestions(dummyQuestions);
        setAnalytics(dummyAnalytics);

        setLoading(false);

    }, []);

    function loadAnalyticsForQuestionnaire(questionnaireId) {
        console.log("Loading analytics for questionnaire:", questionnaireId);
        // Later: REST call here
    }

    return {
        questionnaires,
        users,
        questions,
        analytics,
        loading,
        loadAnalyticsForQuestionnaire
    };
}
